import { linkprops } from "./types";

const threeLinkPlanarArmLinkList: linkprops[] = [
  {
    d: 0,
    theta: 30,
    alpha: 0,
    a: 10,
    type: "revolute",
  },
  {
    d: 0,
    theta: 30,
    alpha: 0,
    a: 10,
    type: "revolute",
  },
  {
    d: 0,
    theta: 30,
    alpha: 0,
    a: 10,
    type: "revolute",
  },
];

const sphericalArmLinkList: linkprops[] = [
  {
    d: 0,
    theta: 30,
    alpha: -90,
    a: 0,
    type: "revolute",
  },
  {
    d: 10,
    theta: 30,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 10,
    theta: 0,
    alpha: 0,
    a: 0,
    type: "prismatic",
  },
];

const anthropomorphicArmLinkList: linkprops[] = [
  {
    d: 10,
    theta: 30,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 0,
    theta: 30,
    alpha: 0,
    a: 10,
    type: "revolute",
  },
  {
    d: 0,
    theta: 30,
    alpha: 0,
    a: 10,
    type: "revolute",
  },
];

const sphericalWristLinkList: linkprops[] = [
  {
    d: 0,
    theta: 30,
    alpha: -90,
    a: 0,
    type: "revolute",
  },
  {
    d: 0,
    theta: 0,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 10,
    theta: 30,
    alpha: 0,
    a: 0,
    type: "revolute",
  },
];

const stanfordManipulatorLinkList: linkprops[] = [
  {
    d: 0,
    theta: 30,
    alpha: -90,
    a: 0,
    type: "revolute",
  },
  {
    d: 10,
    theta: 30,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 10,
    theta: 0,
    alpha: 0,
    a: 0,
    type: "prismatic",
  },
  {
    d: 0,
    theta: 30,
    alpha: -90,
    a: 0,
    type: "revolute",
  },
  {
    d: 0,
    theta: 0,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 10,
    theta: 30,
    alpha: 0,
    a: 0,
    type: "revolute",
  },
];

const anthropomorphicArmSphericalWristLinkList: linkprops[] = [
  {
    d: 10,
    theta: 30,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 0,
    theta: 30,
    alpha: 0,
    a: 10,
    type: "revolute",
  },
  {
    d: 0,
    theta: 30,
    alpha: 0,
    a: 10,
    type: "revolute",
  },
  {
    d: 0,
    theta: 30,
    alpha: -90,
    a: 0,
    type: "revolute",
  },
  {
    d: 0,
    theta: 0,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 10,
    theta: 30,
    alpha: 0,
    a: 0,
    type: "revolute",
  },
];

const dlrManipulatorLinkList: linkprops[] = [
  {
    d: 0,
    theta: 0,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 0,
    theta: 150,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 10,
    theta: 0,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 0,
    theta: 150,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 10,
    theta: 0,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 0,
    theta: 150,
    alpha: 90,
    a: 0,
    type: "revolute",
  },
  {
    d: 10,
    theta: 0,
    alpha: 0,
    a: 0,
    type: "revolute",
  },
];

export {
  threeLinkPlanarArmLinkList,
  sphericalArmLinkList,
  anthropomorphicArmLinkList,
  sphericalWristLinkList,
  stanfordManipulatorLinkList,
  anthropomorphicArmSphericalWristLinkList,
  dlrManipulatorLinkList,
};
